import React from 'react';
export function ReportsOverview() {
  return <div data-id="element-2301">
      <div className="flex justify-between items-center mb-6" data-id="element-2302">
        <h1 className="text-2xl font-bold" data-id="element-2303">Reports</h1>
        <div data-id="element-2304">
          <select className="border border-neutral-300 rounded p-2" data-id="element-2305">
            <option data-id="element-2306">Last 30 Days</option>
            <option data-id="element-2307">Last Quarter</option>
            <option data-id="element-2308">Year to Date</option>
            <option data-id="element-2309">Custom Range</option>
          </select>
        </div>
      </div>
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-2310">
        <div className="bg-white rounded-lg shadow p-6" data-id="element-2311">
          <h2 className="text-lg font-medium mb-4" data-id="element-2312">New Business</h2>
          <div className="flex justify-between items-center" data-id="element-2313">
            <div data-id="element-2314">
              <p className="text-3xl font-bold" data-id="element-2315">12</p>
              <p className="text-sm text-neutral-500" data-id="element-2316">New policies</p>
            </div>
            <div className="text-green-600 font-medium" data-id="element-2317">
              +20% vs prev period
            </div>
          </div>
        </div>
        <div className="bg-white rounded-lg shadow p-6" data-id="element-2318">
          <h2 className="text-lg font-medium mb-4" data-id="element-2319">Revenue</h2>
          <div className="flex justify-between items-center" data-id="element-2320">
            <div data-id="element-2321">
              <p className="text-3xl font-bold" data-id="element-2322">$24,500</p>
              <p className="text-sm text-neutral-500" data-id="element-2323">Total premium</p>
            </div>
            <div className="text-green-600 font-medium" data-id="element-2324">
              +15% vs prev period
            </div>
          </div>
        </div>
        <div className="bg-white rounded-lg shadow p-6" data-id="element-2325">
          <h2 className="text-lg font-medium mb-4" data-id="element-2326">Conversion Rate</h2>
          <div className="flex justify-between items-center" data-id="element-2327">
            <div data-id="element-2328">
              <p className="text-3xl font-bold" data-id="element-2329">32%</p>
              <p className="text-sm text-neutral-500" data-id="element-2330">Lead to client</p>
            </div>
            <div className="text-red-600 font-medium" data-id="element-2331">-5% vs prev period</div>
          </div>
        </div>
      </div>
      <div className="mt-6 bg-white rounded-lg shadow p-6" data-id="element-2332">
        <h2 className="text-lg font-medium mb-4" data-id="element-2333">Monthly Performance</h2>
        <div className="h-64 flex items-center justify-center text-neutral-500" data-id="element-2334">
          Chart placeholder - Monthly sales and conversion data
        </div>
      </div>
    </div>;
}